import React from "react";
import cx from "classnames";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "neutral" | "default" | "outline";
  loading?: boolean;
}

const variants = {
  primary:
    "bg-primary hover:bg-accent border-primary hover:border-accent text-white",
  neutral:
    "bg-neutral-100 hover:bg-neutral-200 border-neutral-100 hover:border-neutral-100 text-primary-complement",
  outline:
    "bg-transparent border border-gray-300 text-gray-700 hover:bg-gray-50",
  default: "",
};

const Button: React.FC<ButtonProps> = ({
  children,
  className,
  variant = "default",
  loading = false,
  disabled,
  ...props
}) => {
  return (
    <button
      {...props}
      disabled={disabled || loading}
      className={cx(
        "inline-flex items-center justify-center px-4 py-2 rounded-md text-sm font-medium transition-colors",
        variants[variant],
        {
          "opacity-50 cursor-not-allowed": disabled || loading,
        },
        className,
      )}
    >
      {loading && (
        <svg
          className="animate-spin -ml-1 mr-2 h-4 w-4 text-current"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      )}

      {children}
    </button>
  );
};

export default Button;
